import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { EMPTY } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";

import { MEDICATION_GETBYID } from "../../../shared/state/actions/data";
import { MedicationApiActions } from "../actions/data/action-creators/medication-api.action";
import { PatientMedicationModel } from "../../../shared/models/patient-medication.model";
import { AWSCommand } from "../../../shared/commands";
import { ApplicationState, MedicationTask } from "../../../shared/types";
import { MedicationUIActions } from "../actions/ui";

@Injectable()
export class MedicationTasksEffects {
	private actions$ = inject(Actions);
	private patientMedicationModel = inject(PatientMedicationModel);
	private store = inject<Store<ApplicationState>>(Store);

	getMedicationTaskById$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(MEDICATION_GETBYID),
			tap(() => this.store.dispatch(MedicationUIActions.loadingIndicator(true))),
			switchMap(({ payload: { patient, medicationId } }) => {
				return this.patientMedicationModel
					.performAction(MedicationApiActions.getMedicationTaskById({ payload: { patient, medicationId } }))
					.pipe(
						// @ts-expect-error TS2345
						map((response: { payload: MedicationTask; command: AWSCommand }) => response.payload),
						map((response: MedicationTask) => {
							response.showOnlyInHistory = true;
							return MedicationApiActions.getMedicationTaskByIdSuccess({
								payload: {
									medicationTask: response,
									patient,
								},
							});
						}),
						tap(() => this.store.dispatch(MedicationUIActions.loadingIndicator(false))),
						catchError(() => {
							this.store.dispatch(MedicationUIActions.loadingIndicator(false));
							return EMPTY;
						}),
					);
			}),
		);
	});
}
